export function getSearchPricingPrototype(search = '') {
    const value = new URLSearchParams(search).get('prototype');
    return ['page-pricing', 'guesty-total-price'].includes(value)
        ? value
        : null;
}

export function getSearchPricingMode(prototype) {
    return prototype === 'guesty-total-price'
        ? 'guesty-total-price'
        : prototype === 'page-pricing'
          ? 'page'
          : null;
}

export function getEndpointSearchPricingMode(endpoint, prototype) {
    const path = new URL(endpoint, 'https://example.invalid').pathname;
    if (path === '/guesty/search/index') return getSearchPricingMode(prototype);
    if (
        path === '/guesty/search/rental-collection' &&
        prototype === 'guesty-total-price'
    )
        return 'guesty-total-price';
    return null;
}
